import React from 'react';
import { Button, ButtonParamType, DefaultButtonStyle } from '../button/revamp-button';
import { Modal } from '../modal/modal';
import './confirm-modal.scss';

type ConfirmModalProps = {
  visible: boolean;
  heading: string;
  showCloseButton?: boolean;
  subtext?: string;
  cancelButtonLabel?: string;
  confirmButtonLabel?: string;
  onCancel?: () => void;
  onConfirm?: () => void;
  automationIdPrefix?: string;
  children?: React.ReactNode;
};

export const ConfirmModal = ({
  visible = false,
  heading = '',
  subtext = '',
  cancelButtonLabel = 'Cancel',
  confirmButtonLabel = 'Confirm',
  onCancel,
  onConfirm,
  automationIdPrefix,
  showCloseButton,
  children,
}: ConfirmModalProps) => (
  <Modal onClose={showCloseButton ? onCancel : undefined} visible={visible} size="small">
    {heading && <h1 className="confirm-modal-heading">{heading}</h1>}
    {subtext && <p className="greyed-sub-heading">{subtext}</p>}

    {children}

    <section className={`button-container ${showCloseButton ? 'button-container-broker' : ''}`}>
      {onCancel && (
        <Button
          buttonStyle={DefaultButtonStyle()
            .hasSecondaryAction()
            .isMediumSize()
            .hasLightMode()
            .build()}
          buttonParams={{
            type: ButtonParamType.NormalButton,
            onClick: onCancel,
          }}
          className="long-button dark-text"
          automationid={`${automationIdPrefix}_${cancelButtonLabel}_Button`}
        >
          {cancelButtonLabel}
        </Button>
      )}

      {onConfirm && (
        <Button
          buttonStyle={DefaultButtonStyle()
            .hasPrimaryAction()
            .isMediumSize()
            .hasLightMode()
            .build()}
          buttonParams={{
            type: ButtonParamType.NormalButton,
            onClick: onConfirm,
          }}
          className="long-button"
          automationid={`${automationIdPrefix}_${confirmButtonLabel}_Button`}
        >
          {confirmButtonLabel}
        </Button>
      )}
    </section>
  </Modal>
);
